/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
var LightHelmet = function (quality) {
  return {
    slot: 'helmet',
    type: 'light',
    quality: quality,
    armorClass: Math.round(4 + quality * 28),
    learning: Math.round(3 + quality * 6),
  };
};
module.exports = LightHelmet;
